import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestConfirmChangeEmail } from "application/changeEmail/changeEmailActions";
import { useHistory, useLocation } from "components/_hooks/useRouter";
import { getQueryStringParam } from "helpers/queryStringHelper";
import { isFailed, isFinished } from "helpers/requestStateHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "routes";
import { oidc } from "services/oidcService";
import urlJoin from "url-join";

const confirmationTokenParamName = "confirmation-token";

export const ChangeEmailConfirmation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const changeEmailConfirmation = useSelector(state => state.changeEmail.changeEmailConfirmation);

  useEffect(() => {
    const confirmationToken = getQueryStringParam(confirmationTokenParamName, location);
    dispatch(requestConfirmChangeEmail(confirmationToken));
  }, []);

  useEffect(() => {
    if (isFinished(changeEmailConfirmation)) {
      const oidcManager = oidc.getOidcManager();
      oidcManager.signout(urlJoin(window.location.origin, routes.changeEmailSuccess));
    }
    if (isFailed(changeEmailConfirmation)) {
      history.replace(routes.changeEmailError);
    }
  }, [changeEmailConfirmation]);

  return <Loader />;
};
